import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Services
//******************************************************************************

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { UserDashboardComponent } from '~/pages/user-dashboard/user-dashboard.component';
import { DetailDialogComponent } from '~/pages/user-dashboard/detail-dialog/detail-dialog.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

const components: any[] = [
    HomeComponent,
    UserDashboardComponent,
    DetailDialogComponent,
];

const services: any[] = [
];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
    ],
    declarations: [
        ...components,
        SafePipe,
    ],
    exports: [
        ...components,
    ],
    providers: [
        ...services,
    ],
})

export class AppImports { }
